import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "setting-up-the-wsk-cli"
    }}>{`Setting up the wsk CLI`}</h1>
    <p>{`Download the executable from the `}<a parentName="p" {...{
        "href": "https://github.com/apache/incubator-openwhisk-cli/releases"
      }}>{`OpenWhisk GitHub repository`}</a>{`. Choose the version that matches your operating system and download the compressed archive.`}</p>
    <p>{`Extract the executable from the compressed archive and place it in a folder of your choice.
Add the folder into which you placed the executable to your PATH environment variable. This enables you to call the CLI from anywhere.`}</p>
    <p>{`Alternatively, you can choose to build OpenWhisk locally; this produces a copy of the CLI. See the `}<a parentName="p" {...{
        "href": "https://github.com/apache/incubator-openwhisk/blob/master/docs/cli.md"
      }}>{`OpenWhisk documentation`}</a>{` for instructions.`}</p>
    <p>{`The OpenWhisk CLI uses a `}<inlineCode parentName="p">{`.wskprops`}</inlineCode>{` file to configure the commands to work with a specific namespace: this means that at any given point in time, the `}<inlineCode parentName="p">{`wsk`}</inlineCode>{` CLI will talk with only with one namespace. If you want to use a different namespace, you have to change the content of the `}<inlineCode parentName="p">{`.wskprops`}</inlineCode>{` file.`}</p>
    <p>{`If you`}{`’`}{`re using the `}<inlineCode parentName="p">{`aio`}</inlineCode>{` CLI, the `}<inlineCode parentName="p">{`.wskprops`}</inlineCode>{` file will be configured automatically for whatever integration you select. You can also use the OpenWhisk CLI by itself, but it requires manual configuration. You will have to create a `}<inlineCode parentName="p">{`.wskprops`}</inlineCode>{` file containing your authorization key, your namespace, and the path to the Runtime API host. Here’s an example:`}</p>
    <pre><code parentName="pre" {...{}}>{`AUTH=<Your UUID>
APIHOST=adobeioruntime.net 
NAMESPACE=<Your namespace>
`}</code></pre>
    <p>{`You place this file in your user folder, where the CLI can access it to set those properties when it starts.`}</p>
    <p>{`An alternative method to configure your instance of the CLI is to do it through a CLI command. Open a command-line window and type the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`wsk property set --apihost adobeioruntime.net  --auth  <Your auth code from the Runtime team>  namespace  <Your namespace from the Runtime team>
`}</code></pre>
    <p>{`Once you`}{`’`}{`ve configured the CLI, you should test it:`}</p>
    <pre><code parentName="pre" {...{}}>{`wsk list
`}</code></pre>
    <p>{`This should list the content of the current namespace.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      